import { useEffect, useState } from "react";
import type { SignupRole } from "../components/Onboarding/onboardingPrompts";

let pending: { workflowId: string; role: SignupRole } | null = null;

export function startOnboarding(workflowId: string, role: SignupRole) {
  pending = { workflowId, role };
}

export function onboardingRole() {
  return pending?.role ?? null;
}

function initialState(workflowId: string) {
  const welcomed = pending?.workflowId === workflowId;
  return { workflowId, onboarding: welcomed, awaitingBuild: welcomed };
}

// Keyed by workflow, since the workflow page stays mounted as you move between workflows.
export function useOnboarding(workflowId: string) {
  const [stored, setStored] = useState(() => initialState(workflowId));
  const state =
    stored.workflowId === workflowId ? stored : initialState(workflowId);
  if (state !== stored) setStored(state);
  useEffect(() => {
    if (!state.onboarding && pending?.workflowId === workflowId) pending = null;
  }, [state.onboarding, workflowId]);
  return {
    ...state,
    finishWelcome: () =>
      setStored((current) => ({ ...current, onboarding: false })),
    revealPanel: () =>
      setStored((current) => ({ ...current, awaitingBuild: false })),
  };
}
